
import React from "react";

export const GameLoadingState = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-16 px-4 bg-background">
      <p className="text-muted-foreground">Loading game...</p>
    </div>
  );
};
